<style>
.view {
	-webkit-transition: all 300ms ease;
	transition: all 300ms ease;
}
.page-prev-enter {
	-webkit-transform: translate(-100%, 0);
	transform: translate(-100%, 0);
}
.page-next-enter {
	-webkit-transform: translate(100%, 0);
	transform: translate(100%, 0);
}
.page-prev-leave-active, .page-next-leave-active {
	opacity: 0;
	transition: none;
}
[v-cloak] {
	display: none;
}
</style>

<template>
	<div id="app" style="height: 100%">
	<transition :name="transitionName" mode="out-in">
		<router-view class="view" keep-alive></router-view>
	</transition>
	</div>
</template>

<script>
const history = []

export default {
	replace: false,
	data () {
		var h = document.body.clientHeight
		return {
			transitionName: 'page-next',
			deviceHeight: h + 'px'
		}
	},
	mounted () {
		// 获取当前可视区域的高度
		// const height = document.documentElement.clientHeight
		// 在页面整体加载完毕时
		// window.onload = function () {
			// 把获取到的高度赋值给根div
			// document.getElementById('app').style.height = `${height}px`
		// }
	},
	watch: {
		'$route' (to, from) {
			const len = history.length - 1
			if (len >= 0 && history[len] === to.path) {
				history.splice(len, 1)
				this.transitionName = 'page-prev'
			} else {
				history.push(from.path)
				this.transitionName = 'page-next'
			}
		}
	}
}
</script>
 


// WEBPACK FOOTER //
// App.vue?19c7b5ca